import { AxiosInstance } from "axios";

import { CallSettingsAPIEndpoints } from "@/api/routes/settings/call-settings";

export const SettingsAPIEndpoints = (client: AxiosInstance) => ({
  call: CallSettingsAPIEndpoints(client),
});
